"use client";

import { useEffect } from "react";
import { useTheme } from "next-themes";

export function AuthThemeForcer() {
    const { setTheme, theme } = useTheme();

    useEffect(() => {
        if (theme !== 'premium') {
            setTheme('premium');
        }
    }, [theme, setTheme]);

    return null;
}
